<lib-filtered-table
  [tableId]="'created-by-me'"
  [tableTitle]="'my_inbox_screen_second_tab_table_title' | transloco"
  [insights]="insights()"
  [dataSource]="dataSource()"
  [meta]="meta()"
  [columns]="columns()"
  [isLoadingData]="isLoading()"
  [tableFilterTabs]="tableFilterTabs()"
  [(payload)]="payload"
  [tableColumnTemplates]="
    [
      { template: number, identifier: COLUMN_IDENTIFIERS.NUMBER },
      { template: id, identifier: COLUMN_IDENTIFIERS.ID },
      { template: name, identifier: COLUMN_IDENTIFIERS.NAME },
      { template: parent_tasks, identifier: COLUMN_IDENTIFIERS.PARENT_TASKS },
      { template: creation_date, identifier: COLUMN_IDENTIFIERS.CREATION_DATE },
      { template: assignees, identifier: COLUMN_IDENTIFIERS.ASSIGNEES },
      { template: sla, identifier: COLUMN_IDENTIFIERS.SLA },
      {
        template: remaining_time,
        identifier: COLUMN_IDENTIFIERS.REMAINING_TIME,
      },
      {
        template: request_subject,
        identifier: COLUMN_IDENTIFIERS.REQUEST_SUBJECT,
      },
      { template: project, identifier: COLUMN_IDENTIFIERS.PROJECT },
      { template: current_step, identifier: COLUMN_IDENTIFIERS.CURRENT_STEP },
      { template: status, identifier: COLUMN_IDENTIFIERS.STATUS },
      {
        template: related_requests,
        identifier: COLUMN_IDENTIFIERS.RELATED_REQUESTS,
      },
      { template: action, identifier: COLUMN_IDENTIFIERS.ACTION },
    ]
      | filterTableColByFeatFlag
        : showParentTasksColumn()
        : COLUMN_IDENTIFIERS.PARENT_TASKS
      | filterTableColByFeatFlag
        : showRelatedRequestsColumn()
        : COLUMN_IDENTIFIERS.RELATED_REQUESTS
  "
  [filterOptions]="filterOptions"
  [filterMapping]="filterMapping"
  [searchPlaceholder]="'my_task_screen_search_input_placeholder'"
  [applyOnStreamChanges]="checkReturnedObservable"
  (streamSucceeds)="handleRequestsSuccess($event)"
  (submitExport)="submitExportForm($event)"
  (handleApiCall)="checkCalledApi()" />

<ng-template #number let-i="i">
  @let metaData = meta();
  @if (metaData) {
    {{ (metaData.current_page - 1) * metaData.per_page + (i + 1) }}
  }
</ng-template>

<ng-template #id let-row>
  {{ row.request_id }}
</ng-template>

<ng-template #name let-row>
  {{ row.name }}
</ng-template>

<ng-template #creation_date let-row>
  <span dir="ltr">
    {{ row.created_at | date: 'dd-MMM-yyyy hh:mm a' }}
  </span>
</ng-template>

<ng-template #assignees let-row>
  @if (row.current_assignees.length) {
    <lib-user-dropdown-view
      [showAssigneeName]="true"
      [userCount]="row.current_assignees.length"
      [userTableList]="row.assignees"
      [userDropdownList]="row.assignees"
      [totalDropdownCount]="row.assignees.length"
      [assigneeType]="row.assigneeType"
      [headerListLabel]="'dropdown_header_list_assignees_label' | transloco"
      [searchLabel]="'dropdown_search_find_assignees_label' | transloco"
      [searchPlaceholder]="'search_by_name_placeholder' | transloco"
      [noSearchResultLabel]="'no_search_result_label' | transloco"
      [enableLocalSearch]="true"
      [imgDimensions]="{ width: 1.5, height: 1.5 }"
      [containerRef]="'created-by-me'" />
  }
</ng-template>

<ng-template #sla let-row>
  <div style="width: 95%">
    @if (row.state.value !== parallelStepStatus.INPROGRESS) {
      <div class="flex gap-sm justify-between">
        <span dir="ltr">
          {{ row.finished_at | date: 'dd-MMM-yyyy hh:mm a' }}
        </span>

        @if (row.finished_at > row.due_date) {
          <lib-warning-icon [iconClass]="'size-4 text-destructive-500'" />
        }
      </div>
    }

    @if (row.state.value === parallelStepStatus.INPROGRESS) {
      <div class="flex">
        <span
          libSla
          [clockTemplate]="clockTemplate"
          [sla]="row.due_date"
          dir="ltr">
          ETA: {{ row.due_date | date: 'dd-MMM-yyyy hh:mm a' }}
        </span>
      </div>
    }
  </div>
</ng-template>

<ng-template #remaining_time let-row>
  @if (
    row.state.value !== parallelStepStatus.COMPLETED &&
    row.state.value !== parallelStepStatus.REJECTED
  ) {
    {{ row.remaining_sla }}
  }
</ng-template>

<ng-template #request_subject let-row>
  <span
    class="inline-block min-w-[10.625rem] max-w-[10.625rem]"
    libTrimTooltip
    placement="top"
    [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top w-[20rem] text-balance'"
    [trimLength]="20"
    [fullText]="row.request_subject">
  </span>
</ng-template>

<ng-template #project let-row>
  @if (row?.project?.name) {
    @if (showProjectLink()) {
      <a
        class="flex items-center gap-md cursor-pointer text-neutral-900 hover:!underline hover:text-primary-500"
        [routerLink]="['/projects' | tenantPath, row.project.id]">
        <lib-avatar
          [size]="'list'"
          [img]="row.project?.image?.url"
          [fullName]="row?.project?.name"
          borderRadius="rounded-full" />
        <span class="text-xs font-medium">{{
          row?.project?.name | truncate
        }}</span>
      </a>
    } @else {
      <div class="flex items-center gap-md text-neutral-900">
        <lib-avatar
          [size]="'list'"
          [img]="row.project?.image?.url"
          [fullName]="row?.project?.name"
          borderRadius="rounded-full" />
        <span class="text-xs font-medium">{{
          row?.project?.name | truncate
        }}</span>
      </div>
    }
  }
</ng-template>

<ng-template #parent_tasks let-row>
  <span>{{ row.container_path || '' }}</span>
</ng-template>

<ng-template #current_step let-row>
  {{ row.current_position_name }}
</ng-template>

<ng-template #status let-row>
  <lib-badge
    [label]="row.state.label"
    [badgeClass]="
      'px-sm border-none text-xs font-medium text-white ' +
      (row.state.value | stepStatus)
    "></lib-badge>
</ng-template>

<ng-template #related_requests let-row>
  <lib-related-requests-dropdown
    [childFlows]="row.child_flows"
    [viewDetailsRouterLink]="getRelatedRequestViewLink" />
</ng-template>

<ng-template #action let-row>
  <lib-action-list
    libPermissions
    [featurePermissions]="[appPermissions.workflow.view]"
    [userPermissions]="row.permissions"
    [menuItems]="getStatusActionList(row.state.value, row.permissions, row.id)"
    [parentName]="'created-by-me'"
    (itemClick)="actionListItemClick($event, row)" />
</ng-template>

<ng-template #archive>
  <lib-archive-confirmation-popup
    [type]="'archive'"
    [isLoading]="isLoading()"
    [titleKey]="'archive_workflow_modal_title'"
    [descriptionKey]="'archive_workflow_modal_description'"
    [highlightedDescriptionKey]="'archive_workflow_modal_highlighted_description'"
    [confirmButtonKey]="'archive_workflow_modal_archive_workflow_button'"
    [cancelButtonKey]="'archive_project_modal_cancel_button'"
    (confirm)="archiveRequest()"
    (closeModal)="closeModal()" />
</ng-template>

<ng-template #restore>
  <lib-archive-confirmation-popup
    [type]="'restore'"
    [isLoading]="isLoading()"
    [titleKey]="'restore_workflow_modal_title'"
    [descriptionKey]="'restore_workflow_modal_description'"
    [highlightedDescriptionKey]="'restore_workflow_modal_highlighted_description'"
    [confirmButtonKey]="'archive_workflow_modal_restore_workflow_button'"
    [cancelButtonKey]="'restore_project_modal_cancel_button'"
    (confirm)="restoreRequest()"
    (closeModal)="closeModal()" />
</ng-template>

<ng-template #clockTemplate let-isOverdue>
  <lib-clock-icon
    [iconClass]="
      'size-4 ' + (isOverdue ? 'text-destructive-500' : 'text-neutral-500')
    " />
</ng-template>
